/*
 * dataLayer ecommerce GA4 — eventos de carrito (Espejoled.com)
 * Intercepta fetch a /cart/add.js para emitir add_to_cart de forma robusta,
 * sin depender de la lógica interna del tema (PRO-Modiva usa fetch).
 * view_cart (página /cart) se emite por Liquid en dl-ecommerce.liquid.
 */
(function () {
  if (window.__dlCartEventsInit) return;
  window.__dlCartEventsInit = true;
  window.dataLayer = window.dataLayer || [];

  function currency() {
    return (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  }

  function toItem(li, index) {
    var price = (li.price != null ? li.price : li.final_price || 0) / 100;
    return {
      item_id: li.sku || String(li.product_id || li.id || ''),
      item_name: li.product_title || li.title || '',
      item_brand: li.vendor || undefined,
      item_category: li.product_type || undefined,
      item_variant: li.variant_title || undefined,
      price: price,
      quantity: li.quantity || 1,
      index: index
    };
  }

  function pushAddToCart(data) {
    // /cart/add.js devuelve el line item, o { items: [...] } en bundles/multi
    var lines = (data && data.items) ? data.items : [data];
    var items = lines.filter(Boolean).map(toItem);
    if (!items.length) return;
    var value = items.reduce(function (s, it) { return s + it.price * it.quantity; }, 0);
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'add_to_cart',
      ecommerce: { currency: currency(), value: Math.round(value * 100) / 100, items: items }
    });
  }

  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function (input, init) {
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      var promise = origFetch.apply(this, arguments);
      if (url && url.indexOf('/cart/add') !== -1) {
        promise.then(function (res) {
          if (!res || !res.ok) return;
          res.clone().json().then(pushAddToCart).catch(function () {});
        }).catch(function () {});
      }
      return promise;
    };
  }
})();
